<template>
	<div class="animated fadeIn">
		<!-- Component -->
		<div class="row">
			<div class="col-12">
				<OverviewCard
					name="Scenario"
				>
                    <b-card>
                        <div slot="header">
                            <div>{{$t('services')}}</div>
                        </div>

						<div class="row" v-if="!new_service_mode">
							<div class="col-sm-12">
								<tooltip
									label="Service name"
									placement="right"
									disabled
									v-if="services.length && !new_service_mode"
								>
									<select v-model="service_posation" class="form-control">
										<option value="-1" disabled="">{{ $t('Choose one') }}</option>
										<option v-for="(service, i) in services" :value="i" :key="`service-${i}`">
											{{ service.service_name }}
										</option>
									</select>
								</tooltip>
							</div>
                            <div class="col-12" v-if="service_posation !== -1">
                                <tooltip
                                    label="service status"
                                    disabled
                                    placement="right"

                                >
                                    <div class="d-b">
                                        <c-switch
                                            class="m-0"
                                            @change="set_service_status"
                                            type="icon"
                                            size="sm"
                                            variant="success"
                                            v-bind="{on: '\uf00c', off: '\uf00d'}"
                                            :pill="true"
                                            :checked="current_service_status"
                                        />
                                    </div>
                                </tooltip>
                            </div>
                            <div class="col-sm-12">
                                <button
                                    class="btn btn-primary btn-sm pull-right"
                                    type="button"
                                    @click="
                                        service_posation = -1
                                        new_service_mode = true
                                        commands = []
                                        cancel_edit_command()
                                    "
                                >
                                    <i class="fa fa-plus"></i>
                                    {{ $t('new service') }}
                                </button>
                            </div>
						</div>
						<div class="row" v-else>
                            <div class="col-12">
                                <tooltip label="service name" disabled placement="right">
                                    <input
                                        name="service_name"
                                        v-model="service_name"
                                        v-validate="'required'"
                                        :placeholder="$t('service name')"
                                        :class="{'form-control': true, 'is-invalid': errors.has('service_name')}"
                                        type="text"
                                    />
                                    <span v-show="errors.has('service_name')" class="help is-danger invalid-feedback">
                                        {{ $t(errors.first('service_name')) }}
                                    </span>
                                </tooltip>
                                <tooltip label="service description" disabled placement="right" v-hide>
                                    <input
                                        name="service_description"
                                        v-model="service_description"
                                        class="form-control"
                                        type="text"
                                    />
                                </tooltip>
                                <div class="form-actions d-block">
                                    <div class="pull-right">
                                        <button
                                            type="button"
                                            class="btn btn-secondary  btn-sm"
                                            @click="new_service_mode = false"
                                        >
                                            <font-awesome-icon icon="ban" />
                                            {{ $t('cancel') }}
                                        </button>
                                        <button type="button" @click.prevent="save_service({service_name, service_description})" class="btn btn-primary btn-sm">
                                            <font-awesome-icon icon="save" />
                                            {{ $t('save') }}
                                        </button>
                                    </div>
                                </div>
							</div>
						</div>
                    </b-card>

                    <b-card v-if="services[service_posation]">
                        <div slot="header">
                            <div v-html="commands_title"></div>
                        </div>
                        <template v-if="commands && commands.length">

                            <table class="table table-bordered table-striped table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th
                                            v-for="(col, i) in command_table_cols"
                                            :key="i"
                                            :class="col == 'action' || col == 'status' ? 'w25 text-center' : 'text-left'"
                                        >
                                            {{ $t(col) }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(record, c_i) in commands">
                                        <template>
                                            <tr :key="`row-${c_i}`">
                                                <td
                                                    v-for="(element, e_i) in record.first_row"
                                                    :key="e_i"
                                                >
                                                    <template v-for="(s_elem, s_e_i) in element">
                                                        <span  v-if="Array.isArray(element)" :key="s_e_i">
                                                            <router-link
                                                                v-if="s_elem.action == 'edit'"
                                                                v-bind:to="s_elem.href"
                                                                class="m-0 p-0 mr-2"

                                                            >


                                                                <font-awesome-icon icon="cog" />

                                                            </router-link>
                                                            <button
                                                                v-if="s_elem.action == 'edit'"
                                                                class="btn btn-link p-0 mr-2"
                                                                @click="edit_command(c_i)"
                                                                type="button"
                                                            >
                                                                <i class="fa fa-edit fa-lg"></i>
                                                            </button>
                                                            <button
                                                                class="btn btn-link p-0 m-0"
                                                                v-if="s_elem.action == 'delete'"
                                                                @click="delete_command(c_i, true)"
                                                                type="button"
                                                            >
                                                                <i class="fa fa-remove fa-lg"></i>
                                                            </button>
                                                            <span v-if="s_elem.action == 'status'">
                                                                <c-switch
                                                                    @change="set_command_status(s_elem)"
                                                                    type="icon"
                                                                    class="m-0 p-0 mr-2"
                                                                    size="sm"
                                                                    variant="success"
                                                                    v-bind="{on: '\uf00c', off: '\uf00d'}"
                                                                    :pill="true"
                                                                    :checked="s_elem.text"
                                                                />
                                                            </span>
                                                        </span>
                                                    </template>
                                                    <span v-if="element.action == 'txt'" class="fw-b">{{ element.text }}</span>
                                                </td>
                                            </tr>
                                            <!-- <tr :key="`row-1-${c_i}`">
                                                <td colspan="2"><p v-html="record.secondary_row" class="m-0"></p></td>
                                            </tr> -->
                                        </template>
                                    </template>
                                    <tr v-if="!commands.length" v-cloak>
                                        <td colspan="2">
                                            <div class="text-center">{{ $t('no data') }}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <ul class="pagination mt-3 mb-0" v-if="command_paging.length > 1">
                                <li v-for="(pg, pg_i) in command_paging" class="page-item" v-bind:class="{active: pg.activate}" :key="pg_i">
                                    <span v-if="pg.activate" class="page-link" aria-hidden="true">{{ pg.btn }}</span>
                                    <span
                                        v-else
                                        class="page-link"
                                        @click="fetch_service_data(service_posation, pg.btn)"
                                        aria-hidden="true"
                                    >
                                        {{ pg.btn }}
                                    </span>
                                </li>
                            </ul>
                            <div class="d-block mb-4"></div>
                        </template>

                        <b-card class="mb-0">
                            <div slot="header">
                                <span v-html="command_form_title"></span>
                            </div>

                            <form id="command__form" @submit.prevent="save_command" autocomplete="off">
                                <tooltip label="command name" placement="right" disabled>
                                    <input
                                        name="command_name"
                                        v-model="command.command_name"
                                        v-validate="'required'"
                                        :class="{'form-control': true, 'is-invalid': errors.has('command_name')}"
                                        type="text"
                                        :placeholder="$t('command name')"
                                    />
                                    <span v-show="errors.has('command_name')" class="help is-danger invalid-feedback">
                                        {{ $t(errors.first('command_name')) }}
                                    </span>
                                </tooltip>

                                <b-card v-if="command.variables && command.variables.length">
                                    <div slot="header">{{ $t('command variables') }}</div>
                                    <table class="table table-bordered table-striped table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th class="text-left">{{ $t('name') }}</th>
                                                <th class="text-center w25">{{ $t('action') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(_var, v_i) in command.variables" :key="v_i">
                                                <td class="text-left">{{ _var.var_name }}</td>
                                                <td class="text-center">
                                                    <router-link
                                                        :to="
                                                            'services/' +
                                                                services[service_posation].service_id +
                                                                '/commands/' +
                                                                command.command_id +
                                                                '/variables/' +
                                                                _var.var_id
                                                        "
                                                        class="m-0 p-0 mr-2"
                                                    >
                                                        <i class="fa fa-edit fa-lg"></i>
                                                    </router-link>
                                                    <button class="btn btn-link p-0 m-0" type="button">
                                                        <i
                                                            class="fa fa-remove fa-lg"
                                                            @click="delete_variable(v_i, true)"
                                                        ></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr v-if="!command.variables.length" v-cloak>
                                                <td colspan="2">
                                                    <div class="text-center">{{ $t('no data') }}</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card>

                                <b-card v-if="command.example">
                                    <div slot="header">{{ $t('command examples') }}</div>
                                    <table class="table table-bordered table-striped table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th class="text-left">{{ $t('example') }}</th>
                                                <th class="text-center w25">{{ $t('action') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(_ex, e_i) in command.example.data[command.example.page]" :key="e_i">
                                                <td>{{ _ex.example_text }}</td>
                                                <td class="text-center">
                                                    <button
                                                        type="button"
                                                        class="btn btn-link m-0 p-0 mr-2"
                                                        @click="edit_example(e_i)"
                                                    >
                                                        <i class="fa fa-edit fa-lg"></i>
                                                    </button>
                                                    <button class="btn btn-link p-0 m-0" type="button">
                                                        <i
                                                            class="fa fa-remove fa-lg"
                                                            @click="delete_example(e_i, true)"
                                                        ></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr v-if="!command.example.data[command.example.page].length" v-cloak>
                                                <td colspan="2">
                                                    <div class="text-center">{{ $t('no data') }}</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="col-12 px-0 ">
                                        <button
                                            class="btn btn-primary btn-sm pull-right mb-0"
                                            type="button"
                                            @click="new_example"
                                            :disabled="this.service_posation === -1"
                                        >
                                            <i class="fa fa-plus"></i>
                                            {{ $t('new example') }}
                                        </button>
                                    </div>
                                </b-card>

                                <b-card class="mb-0">
                                    <div slot="header">
                                        {{ $t('command response') }}
                                    </div>

                                    <div>
                                        <b-nav tabs>
                                            <template v-for="(type, i) in $store.state.command.response.types">
                                                <b-nav-item
                                                    v-if="!type.hide"
                                                    :key="'command.response.types_' + i"
                                                    :disabled="command_posation == -1 && responseTypeisAdvancedMode(type.value)"
                                                    :active="command.response.resp_type === type.value"
                                                    @click="command.response.resp_type = type.value"
                                                >
                                                    {{ $t(type.label) }}
                                                </b-nav-item>
                                            </template>
                                        </b-nav>
                                        <b-card class="border-top-0 mb-0">
                                                <div v-if="command.response.resp_type == 'text'">
                                                    <tooltip label="Text Response" placement="right">
                                                        <textarea
                                                            style="resize: vertical;"
                                                            rows="5"
                                                            name="resp_text"
                                                            :placeholder="$t('Text Response')"
                                                            v-model="command.response.resp_text"
                                                            v-validate="'required'"
                                                            :class="{
                                                                'form-control': true,
                                                                'is-invalid': errors.has('resp_text'),
                                                            }"
                                                            v-autocomplete="autocomplete"
                                                        ></textarea>
                                                        <span
                                                            v-if="errors.has('resp_text')"
                                                            class="help is-danger invalid-feedback"
                                                        >
                                                            {{ $t(errors.first('resp_text')) }}
                                                        </span>
                                                    </tooltip>
                                                </div>


















                                                <div v-else-if="command.response.resp_type == 'static_cards'">
                                                    <table class="table table-bordered table-striped table-sm" v-if="command.response.resp_static_cards_resp_struct && command.response.resp_static_cards_resp_struct.length">
                                                        <thead>
                                                            <tr>
                                                                <th>{{ $t('Title') }}</th>
                                                                <th>{{ $t('Sub title') }}</th>
                                                                <th>{{ $t('actions') }}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(card, ic) in command.response.resp_static_cards_resp_struct" :key="ic">
                                                                <td v-html="card.title_key || card.title_default_value || ''"></td>
                                                                <td v-html="card.subtitle_key || card.subtitle_default_value || ''"></td>
                                                                <td class="text-center">
                                                                    <button type="button" class="btn btn-link p-0 mr-2">
                                                                        <i
                                                                            @click="static_card_emit('edit', ic)"
                                                                            class="fa fa-edit fa-lg"
                                                                            :title="$t('edit')"
                                                                        ></i>
                                                                    </button>
                                                                    <button type="button" class="btn btn-link p-0 mr-2">
                                                                        <i
                                                                            @click="static_card_emit('delete', ic)"
                                                                            class="fa fa-remove fa-lg"
                                                                            :title="$t('delete')"
                                                                        ></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr v-if="!command.response.resp_static_cards_resp_struct.length">
                                                                <td colspan="4">
                                                                    <div class="text-center">{{ $t('no data') }}</div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <b-alert variant="danger" dismissible :show="!!error_resp_static_cards_resp_struct">
                                                        <button type="button" aria-label="Close" class="close"
                                                            @click="error_resp_static_cards_resp_struct = false">×</button>
                                                        <div v-html="error_resp_static_cards_resp_struct"></div>
                                                    </b-alert>


                                                    <ComamandResponseCard
                                                        :buttons="resp_static_cards_resp_struct.buttons"
                                                        :btnLabel="resp_static_cards_resp_struct.item_label_key || resp_static_cards_resp_struct.item_label_default_value"
                                                        :title="resp_static_cards_resp_struct.title_key || resp_static_cards_resp_struct.title_default_value"
                                                        :subTitle="resp_static_cards_resp_struct.subtitle_key || resp_static_cards_resp_struct.subtitle_default_value"
                                                        :autoCompleteModules="autocomplete"
                                                        :checkMediaBackground="true"
                                                        :media="resp_static_cards_resp_struct.media_key || resp_static_cards_resp_struct.media_default_value"
                                                        @onNewButtonClick="push_button(resp_static_cards_resp_struct.buttons)"
                                                        @onRemoveButtonClick="(pos) => remove_button(pos, resp_static_cards_resp_struct.buttons)"
                                                    >
                                                        <template slot="title">
                                                            <tooltip label="title" placement="right">
                                                                <input
                                                                    name="title_key"
                                                                    class="form-control"
                                                                    v-autocomplete="autocomplete"
                                                                    v-model="resp_static_cards_resp_struct.title_key"
                                                                    :placeholder="$t('title')"
                                                                />
                                                            </tooltip>
                                                            <!-- <tooltip label="default value" placement="right">
                                                                <input
                                                                    class="form-control"
                                                                    v-autocomplete="autocomplete"
                                                                    v-model="resp_static_cards_resp_struct.title_default_value"
                                                                    :placeholder="$t('default value')"
                                                                />
                                                            </tooltip> -->
                                                        </template>

                                                        <template slot="subTitle">
                                                            <tooltip label="sub title" placement="right">
                                                                <input
                                                                    class="form-control"
                                                                    v-autocomplete="autocomplete"
                                                                    v-model="resp_static_cards_resp_struct.subtitle_key"
                                                                    :placeholder="$t('sub title')"
                                                                />
                                                            </tooltip>
                                                            <!-- <tooltip label="default value" placement="right">
                                                                <input
                                                                    class="form-control"
                                                                    v-autocomplete="autocomplete"
                                                                    v-model="resp_static_cards_resp_struct.subtitle_default_value"
                                                                    :placeholder="$t('default value')"
                                                                />
                                                            </tooltip> -->
                                                        </template>

                                                        <template slot="media">
                                                            <tooltip label="value" placement="right">
                                                                <image-uploader
                                                                    :imageType="'file'"
                                                                    :imagePreview="false"
                                                                    @imageSelected="image => this.resp_static_cards_resp_struct.media_key = image.dataURI"
                                                                    @linkChanged="link => resp_static_cards_resp_struct.media_key = link"
                                                                ></image-uploader>
                                                            </tooltip>
                                                        </template>


                                                        <template :slot="'button.' + ii" v-for="(button, ii) in  resp_static_cards_resp_struct.buttons">
                                                            <tooltip label="button label" placement="right" :key="'button.label.' + ii">
                                                                <input
                                                                    class="form-control"
                                                                    v-autocomplete="autocomplete"
                                                                    v-model="button.item_label_key"
                                                                    :placeholder="$t('button label')"
                                                                />
                                                            </tooltip>

                                                            <tooltip label="button value" placement="right" :key="'button.value.' + ii">
                                                                <input
                                                                    class="form-control"
                                                                    v-autocomplete="autocomplete"
                                                                    v-model="button.item_value_key"
                                                                    :placeholder="$t('button value')"
                                                                />
                                                            </tooltip>
                                                        </template>
                                                    </ComamandResponseCard>


                                                    <div class="form-group form-actions mt-0 mb-0">
                                                        <button
                                                            :disabled="command.response.resp_static_cards_resp_struct.length >= 5"
                                                            type="button"
                                                            v-show="mode_resp_static_cards_resp_struct == 'add'"
                                                            @click="static_card_emit('add')"
                                                            class="btn btn-primary btn-sm mb-0"
                                                        >
                                                            <font-awesome-icon icon="plus" />

                                                            {{ $t('add') }}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            v-show="mode_resp_static_cards_resp_struct == 'edit'"
                                                            @click="static_card_emit('update')"
                                                            class="btn btn-primary btn-sm mb-0"
                                                        >
                                                            <font-awesome-icon icon="edit" />
                                                            {{ $t('edit') }}
                                                        </button>
                                                    </div>
                                                </div>
































                                                <div v-else>
                                                    <router-link
                                                        :to="
                                                            'services/' +
                                                                services[service_posation].service_id +
                                                                '/commands/' +
                                                                command.command_id +
                                                                '/response'
                                                        "
                                                        class="m-0 p-0 mr-2"
                                                    >
                                                        <i class="fa fa-edit fa-lg icon-link icons font-2x2"></i>
                                                        {{ $t('link to edit command response') }}
                                                    </router-link>
                                                </div>
                                        </b-card>
                                    </div>
                                </b-card>

                                <div class="form-actions">
                                    <button
                                        v-if="command_posation !== -1"
                                        type="button"
                                        class="btn  btn-secondary  btn-md mb-0"
                                        @click="cancel_edit_command"
                                    >
                                    <font-awesome-icon icon="ban" />
                                        {{ $t('cancel') }}
                                    </button>
                                    <button
                                        type="submit"
                                        :disabled="this.service_posation === -1"
                                        form="command__form"
                                        class="btn  btn-primary btn-md mb-0 "
                                    >
                                    <font-awesome-icon icon="save" />
                                        {{ $t('save') }}
                                    </button>
                                </div>
                            </form>

                        </b-card>


                    </b-card>






				</OverviewCard>
			</div>
		</div>
		<b-modal title="Modal title" class="modal-primary" v-model="show_delete_modal" @ok="delete_model">
			{{ $t('Do you really need to delete') }} {{ active_delete_name }} ?
		</b-modal>

		<b-modal
			size="lg"
			ref="example_modal"
			:title="$t('Command Example modal title')"
			:no-close-on-backdrop="true"
			hide-footer
			@ok="handle_modal_example('ok')"
			@cancel="handle_modal_example('cancel')"
			@hide="handle_modal_example('hide')"
		>
			<div class="row">
				<div class="col-sm-12">
					<tooltip label="example" placement="right">
						<textarea
							style="resize: vertical;"
							rows="3"
							name="example_text"
							v-model="react_example.example_text"
							v-validate="'required'"

							:class="{'form-control': true, 'is-invalid': errors.has('example_text')}"
						></textarea>
						<span v-show="errors.has('example_text')" class="help is-danger invalid-feedback">
							{{ $t(errors.first('example_text')) }}
						</span>
					</tooltip>
					<p v-if="react_example.variables.length">
						<button type="button" class="btn btn-sm btn-default" @click="tag">{{ $t('Tag') }}</button>
					</p>
					<table
						v-show="react_example.example_vars.length > 0"
						class="table table-bordered table-striped table-sm"
					>
						<thead>
							<tr>
								<td>{{ $t('Tag') }}</td>
								<td>{{ $t('Variable') }}</td>
								<td class="text-center">{{ $t('action') }}</td>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(ex_var, _ind) in react_example.example_vars" :key="_ind">
								<td style="line-height: 2.22322rem;">{{ ex_var.tag }}</td>
								<td>
									<select class="form-control input-sm" v-model="ex_var.type">
										<option v-for="(v, i) in react_example.variables" :value="v.var_id" :key="i">
											{{ v.var_name }}
										</option>
									</select>
								</td>
								<td style="line-height: 2.22322rem;" class="text-center">
									<button
										class="btn btn-link p-0 m-0"
										@click="react_example.example_vars.splice(_ind, 1)"
									>
										<i class="fa fa-remove fa-lg"></i>
									</button>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="form-actions">
						<button
							type="button"
							@click="handle_modal_example(react_example.mode)"
							class="btn btn-square btn-primary btn-sm"
						>
							<i class="fa fa-dot-circle-o"></i>
							{{ $t(react_example.mode) }}
						</button>
						<button
							type="button"
							@click="handle_modal_example('cancel')"
							class="btn btn-square btn-secondary btn-sm"
						>
							<i class="fa fa-ban"></i>
							{{ $t('cancel') }}
						</button>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
import axios from 'axios'

import {cSwitch, OverviewCard} from '../../components'
import ComamandResponseCard from '../../components/ComamandResponseCard'
import GeoLocation from '../../components/GeoLocation'

import ImageUploader from '../../components/ImageUploader'

export default {
	name: 'SimpleScenario',
    mixins: [],

	components: {
		cSwitch,
		OverviewCard,
        ComamandResponseCard,
        GeoLocation,
        ImageUploader
    },

	data() {
		return {
            dropzoneOptions: {
                url: `server/api/upload-image/static-cards`,
                thumbnailWidth: 150,
            },
			service_posation: -1,
			command_posation: -1,
			services: [],
			commands: [],
			command_paging: [],

			new_service_mode: false,
			service_name: null,
			service_description: null,

			command_table_cols: ['name', 'action'],

			show_delete_modal: false,
			active_delete_posation: null,
			active_delete_name: null,
			active_delete_action: null,

			text_selection: '',
			command: {
				mode: 'add',
				command_id: 0,
				service_id: 0,
				command_name: '',
				command_description: '',
				variables: [],
				example: {
					page: 1,
					pages_count: 1,
					data: {
						1: [],
					},
					pagination: [],
				},
                response: {
                    resp_type: 'text',
                    resp_text: '',
                    resp_data_source_id: 0,
                    resp_data_source_query_string: '',
                    resp_api_url: '',
                    resp_api_req_type: 'get',
                    resp_sub_channel: 0,
                    resp_api_headers: '',
                    resp_api_pars: [],
                    resp_action_api_pars: [],
                    resp_user_data_pars: [],
                    resp_api_resp_type: 'json',
                    resp_api_resp_data_field: '',
                    resp_user_data_mode_name: '',
                    resp_api_resp_data_type: 'single',
                    resp_api_resp_data_limit: 3,
                    resp_api_resp_via: 'text',
                    resp_api_resp_struct: {
                        title_key: '',
                        title_default_value: '',
                        subtitle_key: '',
                        subtitle_default_value: '',
                        media_key: '',
                        media_default_value: '',
                        item_label_key: '',
                        item_label_default_value: '',
                        item_value_key: '',
                        item_value_default_value: '',
                        buttons: [
                            {
                                item_label_key: '',
                                item_label_default_value: '',
                                item_value_key: '',
                                item_value_default_value: '',
                            }
                        ],
                    },
                    resp_static_cards_resp_struct: [],
                    resp_location_resp_struct: [],
                    resp_api_extra_resp: [],
                    resp_action_type: '',
                    resp_action_mail_to: [],
                    resp_action_mail_title: '',
                    resp_action_mail_msg: '',
                    resp_action_api_url: '',
                    resp_action_api_req_type: '',
                    resp_action_api_headers: '',
                    resp_user_data_dataset_id: 0,
                    resp_data_source_resp_data_limit: 3,
                    resp_data_source_resp_via: 'text',
                    resp_data_source_resp_struct: {
                        title_key: '',
                        title_default_value: '',
                        subtitle_key: '',
                        subtitle_default_value: '',
                        media_key: '',
                        media_default_value: '',
                        item_label_key: '',
                        item_label_default_value: '',
                        item_value_key: '',
                        item_value_default_value: '',
                        buttons: [
                            {
                                item_label_key: '',
                                item_label_default_value: '',
                                item_value_key: '',
                                item_value_default_value: '',
                            }
                        ],
                    },
                    resp_dataset: {
                        ds_id: 0,
                        ds_data: {},
                        query_type: 'builder',
                        groups: [[]],
                        query_syntax: [],
                        resp: {
                            limit: 1,
                            via: 'text',
                            title: '',
                            subtitle: '',
                            media: '',
                            item_label: '',
                            item_value: '',
                            fallback_msg: '',
                            buttons: [{
                                item_label_key: '',
                                // item_label_default_value: '',
                                item_value_key: '',
                                // item_value_default_value: '',
                            }],
                            receipt: {
                                name: '',
                                merchant: '',
                                order_number: 0,
                                timestamp: 0,
                                order_url: 0,
                                currency: 'EGP',
                                payment_method: '',
                                dataset_id: 0,
                                elem_title_col: '',
                                elem_price_col: 0,
                                elem_amount_col: 1,
                                elem_image_col: '',
                                address: '',
                                sub_total: 0,
                                shipping_cost: 0,
                                total_tax: 0,
                                total_cost: 0,
                            },
                        },
                    }
                },
			},
			react_example: {
				example_command_id: 0,
				_id: 0,
				example_status: 1,
				example_text: '',
				example_vars: [],
				variables: [],
				mode: 'add',
			},
			autocomplete: {},
            mode_resp_static_cards_resp_struct: 'add',
            error_resp_static_cards_resp_struct: false,
            resp_static_cards_resp_struct: {
                title_key: '',
                title_default_value: '',
                subtitle_key: '',
                subtitle_default_value: '',
                media_key: '',
                media_default_value: '',
                buttons: [
                    {
                        item_label_key: '',
                        item_label_default_value: '',
                        item_value_key: '',
                        item_value_default_value: '',
                    }
                ],
            },
            resp_location_resp_struct: {
                mode: 'add',
                error: false,
                title: '',
                lng: 0,
                lat: 0,
            },
		}
    },

	computed: {
		current_service_status() {
			return this.services[this.service_posation] && !!this.services[this.service_posation].service_status
		},

		service_status_label() {
			return (
				this.services[this.service_posation] &&
				'<b>' + this.services[this.service_posation].service_name + '</b> ' + this.$t('status', ':')
			)
		},

		commands_title() {
			return (
                this.$t('commands')
                // + (this.services[this.service_posation] ? ' ' + this.$t('for service') + ' ' : '') +
				// (this.services[this.service_posation]
				// 	? '(' + this.services[this.service_posation].service_name + ')'
				// 	: '')
			)
		},

		command_form_title() {
			return (
				this.$t(this.command_posation === -1 ? 'new' : 'edit') +
				' ' +
                this.$t('command')
                // + (this.command_posation !== -1 &&
				// this.services[this.service_posation].commands.data[
				// 	this.services[this.service_posation].commands.page
				// ] &&
				// this.services[this.service_posation].commands.data[this.services[this.service_posation].commands.page]
				// 	.data[this.command_posation]
				// 	? ' (' +
				// 	  this.services[this.service_posation].commands.data[
				// 			this.services[this.service_posation].commands.page
				// 	  ].data[this.command_posation].apis.about.command_name +
				// 	  ')'
				// 	: '') +
				// (this.services[this.service_posation] ? ' ' + this.$t('for service') + ' ' : '') +
				// (this.services[this.service_posation]
				// 	? '(' + this.services[this.service_posation].service_name + ')'
				// 	: '')
			)
		},
    },

	created() {
		this.$root.loader = true
        this.__update_autocomplete_structure()
		// document.onmouseup =
		document.onkeyup = document.onselectionchange = () => {
			var text = getSelectionText()
			if (text) {
				this.text_selection = text
			} else {
				this.text_selection = ''
			}
		}

		axios.get('/service/get_list').then((res) => {
			if (res.data.status) {
				this.services = [].concat(
					res.data.private.reduce((a, b) => {
						return a.concat({
							...b,
							commands: {
								page: 1,
								pages_count: 1,
								pagination: null,
								data: {},
							},
						})
					}, []),
					/*res.data.public*/ []
				)

				this.$root.loader = false
			}
		})
    },

	watch: {
		service_posation(n, o) {
			if (n != o && this.services[n]) {
				this.command_posation = -1
				this.__reset_command_form()
				this.fetch_service_data(n, this.services[n].commands.page)
			}
		},
    },

	methods: {

		search() {
			// alert(this.keywords)
        },

        responseTypeisAdvancedMode(type) {
            return ['sub', 'api', 'ds', 'data_source', 'component', 'shopping_cart', 'menu'].indexOf(type) >= 0;
        },

		fetch_service_data(service_posation, page = 0) {
			page = parseInt(page)
			var service = this.services[service_posation]
			service.commands.page = page
			if (service.commands.data[page]) {
				this.commands = service.commands.data[page].data
				this.__set_paging(service.commands.pages_count, page, (pagination_bar) => {
					service.commands.pagination = pagination_bar
					this.command_paging = pagination_bar
				})
			} else {
				this.$root.loader = true
				service.commands.data[page] = {}
				axios.get('/command/get/' + service.service_id + '/' + page).then((res) => {
					this.commands = []
					this.command.service_id = service.service_id
					if (res.data.status) {
						var commands = []
						service.commands.pages_count = res.data.pages_count
						service.commands.data[page].data = []
						if (res.data.data.length) {
							for (var i = 0; i < res.data.data.length; i++) {
								var new_command_posation = i,
									service_id = service.service_id,
									new_command = res.data.data[i],
									callback = (command, pos) => {
										if (pos === res.data.data.length - 1) {
											this.$root.loader = !true
											this.__set_paging(service.commands.pages_count, page, (paging) => {
												service.commands.pagination = paging
												this.command_paging = paging
											})
										}
										this.commands.push(command)
										service.commands.data[page].data.push(command)
									}

								this.__build_command_structure(new_command_posation, service_id, new_command, callback)
							}
						} else {
							this.$root.loader = !true
						}
					}
				})
			}
		},

		set_service_status() {
			var service = this.services[this.service_posation]
			if (service) {
				service.service_status = !service.service_status
				axios.post('/service/set_status/' + service.service_id, {status: service.service_status})
			}
		},

		save_service(data) {
			if (!this.service_name && !this.errors.has('service_name')) {
				this.errors.add({
					field: 'service_name',
					msg: 'The service_name field is required.',
				})
			}

			if (!this.errors.count()) {
				this.$root.loader = true
				axios.post('/service/save/0', data).then((res) => {
					this.$root.loader = false
					if (res.data.status) {
						this.services.push({
							...data,
							service_status: 1,
							service_id: res.data.id,
							commands: {
								page: 1,
								pages_count: 1,
								pagination: null,
								data: {},
							},
						})
						this.$store.commit('add_go_services', {
							service_id: res.data.id,
							service_name: data.service_name,
						})
						this.new_service_mode = false
						this.service_description = this.service_name = null
						this.service_posation = this.services.length - 1
					}
				})
			}
		},

		set_command_status(element) {
			var status = 1
			if (element.text != false) {
				status = 0 // reverse the current status
			}
			axios.post('/command/set_status/' + element.id, {status: status})
		},

		delete_model() {
			this['delete_' + this.active_delete_action](this.active_delete_posation, false)
		},

		edit_command(command_posation) {
			var service = this.services[this.service_posation]
			if (service) {
				this.__reset_command_form()
				var command = service.commands.data[service.commands.page].data[command_posation]
				if (command) {
					this.command_posation = command_posation
					// set command about
					this.command.mode = 'edit'
					this.command.command_id = command.apis.about.command_id
					this.command.command_name = command.apis.about.command_name
					this.command.command_description = command.apis.about.command_description
					// set command variables
					this.command.variables = command.apis.variables
					// set command examples
					this.command.example = command.apis.example
					// set command response
					command.apis.response = Object.assign(
						this.command.response,
						is_obj(command.apis.response) ? command.apis.response : {}
					)
					this.command.response = JSON.parse(JSON.stringify(command.apis.response))
					this.__update_autocomplete_structure()
				}
			}
		},

		delete_command(command_posation, alarm) {
			this.$root.loader = false
			var service = this.services[this.service_posation]
			if (service) {
				var command = service.commands.data[service.commands.page].data[command_posation]
				if (command) {
					if (alarm) {
						this.show_delete_modal = true
						this.active_delete_action = 'command'
						this.active_delete_posation = command_posation
						this.active_delete_name = command.apis.about.command_name
					} else {
						this.$root.loader = true
						axios.post('/command/delete/' + command.apis.about.command_id).then((res) => {
							if (res.data.status) {
								this.show_delete_modal = false
								this.$store.commit('delete_go_commands', command.apis.about.command_id)
								service.commands.data[service.commands.page].data.splice(command_posation, 1)

								if (!service.commands.data[service.commands.page].data.length) {
									if (service.commands.data[service.commands.page - 1]) {
										--service.commands.pages_count
										--service.commands.page
									}
								}

								this.fetch_service_data(this.service_posation, service.commands.page)
							}
							this.$root.loader = !true
						})
					}
				}
			}
		},

		cancel_edit_command() {
			this.command_posation = -1
			this.__reset_command_form()
		},

		save_command() {
			var _c, _cs, _x, _mc, _s, _exs

			_s = this.services[this.service_posation]
			_c = this.command
			_cs = this.commands

            if(this.errors.has('example_text'))
                this.errors.remove('example_text')

			if (!_c.command_name.length) {
                if (!this.errors.has('command_name')) {
                    this.errors.add({
                        field: 'command_name',
                        msg: 'The command_name field is required.',
                    })
                }
            } else
				this.errors.remove('command_name')

			if (_c.response.resp_type == 'text' && !_c.response.resp_text.length) {
                if (!this.errors.has('resp_text')) {
                    this.errors.add({
                        field: 'resp_text',
                        msg: 'The command_name field is required.',
                    })
                }
            } else
				this.errors.remove('resp_text')

            if (!this.errors.count()) {
                this.$root.loader = true
                var command_path = '/command/save/' + _c.service_id + '/' + _c.command_id
                var command_data = {
                    command_name: _c.command_name,
                    command_description: _c.command_description,
                }
                axios
                    .post(command_path, command_data
                    )
                    .then((res) => {
                        if (res.data.status) {
                            _c.command_id = res.data.id
                            // save (new|edit) example(s)
                            this.__save_examples(_c.example, _c.command_id, () => {
                                // save command response
                                var cmd_res_path = '/command_response/save/' + _c.command_id
                                var cmd_res_data = {
                                    record: _c.response,
                                }
                                axios
                                    .post(cmd_res_path, cmd_res_data
                                    )
                                    .then((res) => {
                                        // dump(res)
                                        if (_c.mode === 'edit') {
                                            // edit a exist command
                                            _mc = _cs[this.command_posation]
                                            _mc.apis.response = _c.response
                                            _mc.apis.about.command_name = _c.command_name
                                            _mc.apis.about.command_description = _c.command_description
                                            _mc['first_row'][0]['text'] = _c.command_name
                                            _mc['secondary_row'] = this.__build_command_secondary_row(_c.response)
                                            this.cancel_edit_command()
                                            this.$root.loader = !true
                                            this.$root.notify({
                                                message: this.$t('successfully updated'),
                                                status: 'success',
                                                area: 'topRight',
                                            })
                                        } else {
                                            // add new command
                                            // dump(this.command_posation)
                                            // dump(_c)
                                            // dump(this.commands)
                                            var new_command_posation = _cs.length,
                                                service_id = _c.service_id,
                                                new_command = {
                                                    command_id: _c.command_id,
                                                    command_name: _c.command_name,
                                                    command_description: _c.command_description,
                                                    command_service_id: _c.service_id,
                                                    command_status: 1,
                                                },
                                                callback = (command, pos) => {
                                                    // dump(command, pos, _s)
                                                    _cs.push(command)
                                                    _s.commands.data[_s.commands.page].data.push(command)
                                                    this.edit_command(pos)
                                                    this.cancel_edit_command()
                                                    this.$root.loader = !true
                                                    this.$root.notify({
                                                        message: this.$t('successfully saved'),
                                                        status: 'success',
                                                        area: 'topRight',
                                                    })
                                                }

                                            this.__build_command_structure(
                                                new_command_posation,
                                                service_id,
                                                new_command,
                                                callback
                                            )
                                        }
                                    })
                            })
                        }
                    })
            }

        },

		delete_variable(variable_posation, alarm) {
			var variable = this.command.variables[variable_posation]
			if (variable) {
				if (alarm) {
					this.show_delete_modal = true
					this.active_delete_action = 'variable'
					this.active_delete_posation = variable_posation
					this.active_delete_name = variable.var_name
				} else {
					this.$root.loader = true
					this.show_delete_modal = !true

					variable = this.services[this.service_posation].commands.data[
						this.services[this.service_posation].commands.page
					].data[this.command_posation].apis.variables.splice(variable_posation, 1)[0]

					axios.post('/command_var/delete/' + variable.var_id).then((res) => {
						this.$root.loader = !true
						if (res.data.status) {
							this.$store.commit('delete_go_variables', variable.var_id)
						}
					})
				}
			}
		},

		new_example() {
			var service = this.services[this.service_posation]
			if (service) {
				// var command = service.commands.data[service.commands.page].data[this.command_posation]
				// if(command) {
				//     this.react_example.example_command_id = command.apis.about.command_id
				//     this.react_example.variables = command.apis.variables
				// } else {
				//     this.react_example.example_command_id = 0
				//     this.react_example.variables = []
				// }

				this.react_example.example_command_id = this.command.command_id
				this.react_example.variables = this.command.variables

				this.$refs.example_modal.show()
				this.errors.remove('example_text')
			}
		},

		edit_example(example_posation) {
			var service = this.services[this.service_posation]
			if (service) {
				var command = this.command
				// if(command) {
				//     this.react_example.example_command_id = command.apis.about.command_id
				//     this.react_example.variables = command.apis.variables
				// } else {
				//     this.react_example.example_command_id = 0
				//     this.react_example.variables = []
				// }

				try {
					var example = command.example.data[command.example.page][example_posation]
					this.react_example = {
						...example,
						mode: 'edit',
						posation: example_posation,
						variables: command.variables,
						example_vars: example.example_vars.slice(),
					}

					this.$refs.example_modal.show()
					this.errors.remove('example_text')
				} catch (e) {}

				// if(command) {
				//     var examples = command.apis.example
				//     if(examples) {
				//         var example = examples.data[examples.page][example_posation]
				//         if(example) {

				//         }
				//     }
				// }
			}
		},

		delete_example(example_posation, alarm) {

            var examples = this.command.example.data[this.command.example.page];

            if(examples) {
                var example = examples[example_posation];
                if(example) {

                    if (alarm) {
                        this.show_delete_modal = true
                        this.active_delete_action = 'example'
                        this.active_delete_posation = example_posation
                        this.active_delete_name = example.example_text
                        return;
                    }

                    this.show_delete_modal = !true
                    example = examples.splice(this.active_delete_posation, 1)[0];

                    if(example && example._id)
                        axios.delete('/command_example/delete/' + example._id)

                }
            }
		},

		get_example(page) {
			var service = this.services[this.service_posation]
			if (service) {
				var command = service.commands.data[service.commands.page].data[this.command_posation]
				if (command) {
					var example = command.apis.example
					if (example) {
						if (example.data[page]) {
							example.page = parseInt(page)
							this.__set_paging(example.pages_count, example.page, (paging) => {
								example.pagination = paging
							})
						} else {
							axios
								.get('/command_example/get/' + command.apis.about.command_id)
								.then((res) => {
									if (res.data.status) {
										example.data[page] = res.data.data
										example.page = parseInt(page)
										this.__set_paging(example.pages_count, example.page, (paging) => {
											example.pagination = paging
										})
									}
								})
						}
					}
				}
			}
		},

		handle_modal_example(mode) {
			switch (mode) {
				case 'add':
				case 'edit':
					if (!this.react_example.example_text.length) {
                        this.errors.remove('example_text')
						this.errors.add({
							field: 'example_text',
							msg: 'The example_text field is required.',
						})
					} else {
						this.errors.remove('example_text')
					}

					if (this.react_example.example_text.length) {
						if ('add' == mode) {
							this.command.example.data[this.command.example.page].push({
								...this.react_example,
								posation: this.command.example.data[this.command.example.page].length,
							})
						} else if ('edit' == mode) {
							// dump(this.react_example)
							this.command.example.data[this.command.example.page][this.react_example.posation] = {
								...this.react_example,
								example_vars: this.react_example.example_vars,
							}

							// dump(this.command.example.data[this.command.example.page][this.react_example.posation])
						}
						this.handle_modal_example('cancel')
					}

					break
				case 'cancel':
					// this.errors.remove('example_text')
					this.$refs.example_modal.hide()
					break
				case 'hide':
					this.react_example = {
						// modal_status: false,
						example_command_id: 0,
						_id: 0,
						example_status: 1,
						example_text: '',
						example_vars: [],
						variables: [],
						mode: 'add',
					}
					this.errors.remove('example_text')
                    break
			}
		},

		tag() {
			var tag = this.text_selection.trim()
			if (tag && tag.length) {
				this.react_example.example_vars.push({
					tag: tag,
					type: this.react_example.variables[0].var_id,
				})
			}
			this.text_selection = ''
		},


        push_button(btns) {
            btns.push({
                item_label_key: '',
                item_label_default_value: '',
                item_value_key: '',
                item_value_default_value: '',
            })
        },

        remove_button(pos, btns) {
            btns.splice(pos, 1)
        },

        static_card_emit(mode, pos) {
            var card = this.resp_static_cards_resp_struct
            var cards = this.command.response.resp_static_cards_resp_struct || []
            var empty_card = {
                title_key: '',
                title_default_value: '',
                subtitle_key: '',
                subtitle_default_value: '',
                media_key: '',
                media_default_value: '',
                buttons: [
                    {
                        item_label_key: '',
                        item_label_default_value: '',
                        item_value_key: '',
                        item_value_default_value: '',
                    }
                ],
            }
            // check if a valid card
            if(
                (mode !== 'edit' && mode !== 'delete')
                && (
                    (!card.media_key.length && !card.media_default_value.length) ||
                    (!card.title_key.length && !card.title_default_value.length)
                )
            ) {
                this.error_resp_static_cards_resp_struct = 'please complete required fields like media & title!'
                return false
            } else {
                this.error_resp_static_cards_resp_struct = false
            }

            switch(mode) {
                case 'add':
                    if(cards.length < 5) {
                        cards.push(card)
                        this.resp_static_cards_resp_struct = {
                            ...empty_card
                        }
                    }
                break
                case 'edit':
                    this.resp_static_cards_resp_struct = {
                        pos: pos,
                        ...cards[pos],
                    }
                    this.mode_resp_static_cards_resp_struct = 'edit'
                break
                case 'update':
                    if(is_num(card.pos)) {
                        pos = card.pos
                        delete card['pos']
                        cards[pos] = { ...card }
                        this.resp_static_cards_resp_struct = {
                            ...empty_card
                        }
                        this.mode_resp_static_cards_resp_struct = 'add'
                    }
                break
                case 'delete':
                    if(is_num(pos)) {
                        cards.splice(pos, 1)
                    }
                break
            }
        },

        location_emit(mode, pos) {
            var location = this.resp_location_resp_struct
            var locations = this.command.response.resp_location_resp_struct || []
            var empty_location = {
                mode: 'add',
                error: false,
                title: '',
                lng: 0,
                lat: 0,
            }
            // check if a valid location
            if(
                (mode !== 'edit' && mode !== 'delete')
                && (!is_num(location.lng) || !is_num(location.lat))
            ) {
                this.resp_location_resp_struct.error = 'please complete required fields!'
                return false
            } else {
                this.resp_location_resp_struct.error = false
            }

            switch(mode) {
                case 'add':
                    if(locations.length < 5) {
                        locations.push({
                            title: location.title,
                            lng: location.lng,
                            lat: location.lat,
                        })
                        this.resp_location_resp_struct = { ...empty_location }
                    }
                break
                case 'edit':
                    this.resp_location_resp_struct = {
                        mode: 'edit',
                        pos: pos,
                        ...locations[pos],
                    }
                break
                case 'update':
                    if(is_num(location.pos)) {
                        pos = location.pos
                        locations[pos] = {
                            title: location.title,
                            lng: location.lng,
                            lat: location.lat,
                        }

                        this.resp_location_resp_struct = { ...empty_location }
                    }
                break
                case 'delete':
                    if(is_num(pos)) {
                        locations.splice(pos, 1)
                    }
                break
            }
        },

        // @methods
		/**
		 * Helper methods
		 */
		__reset_command_form() {
			this.command = Object.assign(this.command, {
				mode: 'add',
				command_id: 0,
				command_name: '',
				command_description: '',
				variables: [],
				example: {
					page: 1,
					pages_count: 1,
					data: {
						1: [],
					},
					pagination: [],
				},
                response: {
                    resp_actions: [],
                    resp_type: 'text',
                    resp_text: '',
                    resp_data_source_id: 0,
                    resp_data_source_query_string: '',
                    resp_api_url: '',
                    resp_api_req_type: 'get',
                    resp_sub_channel: 0,
                    resp_api_headers: '',
                    resp_api_pars: [],
                    resp_action_api_pars: [],
                    resp_user_data_pars: [],
                    resp_api_resp_type: 'json',
                    resp_api_resp_data_field: '',
                    resp_user_data_mode_name: '',
                    resp_api_resp_data_type: 'single',
                    resp_api_resp_data_limit: 3,
                    resp_api_resp_via: 'text',
                    resp_api_resp_struct: {
                        title_key: '',
                        title_default_value: '',
                        subtitle_key: '',
                        subtitle_default_value: '',
                        media_key: '',
                        media_default_value: '',
                        item_label_key: '',
                        item_label_default_value: '',
                        item_value_key: '',
                        item_value_default_value: '',
                        buttons: [
                            {
                                item_label_key: '',
                                item_label_default_value: '',
                                item_value_key: '',
                                item_value_default_value: '',
                            }
                        ],
                    },
                    resp_static_cards_resp_struct: [],
                    resp_location_resp_struct: [],
                    resp_api_extra_resp: [],
                    resp_action_type: '',
                    resp_action_mail_to: [],
                    resp_action_mail_title: '',
                    resp_action_mail_msg: '',
                    resp_action_api_url: '',
                    resp_action_api_req_type: '',
                    resp_action_api_headers: '',
                    resp_user_data_dataset_id: 0,
                    resp_data_source_resp_data_limit: 3,
                    resp_data_source_resp_via: 'text',
                    resp_data_source_resp_struct: {
                        title_key: '',
                        title_default_value: '',
                        subtitle_key: '',
                        subtitle_default_value: '',
                        media_key: '',
                        media_default_value: '',
                        item_label_key: '',
                        item_label_default_value: '',
                        item_value_key: '',
                        item_value_default_value: '',
                        buttons: [
                            {
                                item_label_key: '',
                                item_label_default_value: '',
                                item_value_key: '',
                                item_value_default_value: '',
                            }
                        ],
                    },
                    resp_dataset: {
                        ds_id: 0,
                        ds_data: {},
                        query_type: 'builder',
                        groups: [[]],
                        query_syntax: [],
                        resp: {
                            limit: 1,
                            via: 'text',
                            title: '',
                            subtitle: '',
                            media: '',
                            item_label: '',
                            item_value: '',
                            fallback_msg: '',
                            buttons: [{
                                item_label_key: '',
                                // item_label_default_value: '',
                                item_value_key: '',
                                // item_value_default_value: '',
                            }],
                            receipt: {
                                name: '',
                                merchant: '',
                                order_number: 0,
                                timestamp: 0,
                                order_url: 0,
                                currency: 'EGP',
                                payment_method: '',
                                dataset_id: 0,
                                elem_title_col: '',
                                elem_price_col: 0,
                                elem_amount_col: 1,
                                elem_image_col: '',
                                address: '',
                                sub_total: 0,
                                shipping_cost: 0,
                                total_tax: 0,
                                total_cost: 0,
                            },
                        },
                    }
                },
			})
            this.__update_autocomplete_structure()
            setTimeout(() => {
                this.errors.clear()
    			this.errors.remove('resp_text')
            })
		},

		__build_command_structure(new_command_posation, service_id, new_command, callback) {
			var command_posation = {
					command_posation: new_command_posation,
				},
				command = {
					service_id,
					...command_posation,
					first_row: [
						{
							text: new_command['command_name'],
							link: false,
							action: 'txt',
							id: new_command['command_id'],
							...command_posation,
						},
						[
							{
								text: parseInt(new_command['command_status']) == 1 ? true : false,
								link: false,
								action: 'status',
								id: new_command['command_id'],
								...command_posation,
							},
							{
								id: new_command['command_id'],
								service_id: service_id,
								link: true,
								href: '/services/' + service_id + '/commands/' + new_command['command_id'],
								action: 'edit',
								...command_posation,
							},
							{
								text: new_command['command_name'],
								link: false,
								action: 'delete',
								id: new_command['command_id'],
								...command_posation,
							},
						],
					],
					secondary_row: '...',
					apis: {
						about: new_command,
						variables: [],
						response: null,
						dataset: null,
						example: {
							page: 1,
							pages_count: 1,
							data: {
								1: [],
							},
							pagination: [],
						},
					},
				}

			// commands.push()

			// setTimeout(() => {
			axios
				.get('/command_response/get/' + new_command['command_id'])
				.then((res) => {
					command.apis.response = res.data.status ? res.data.data : null
					command.secondary_row = this.__build_command_secondary_row(command.apis.response)

					// }

					// if(is_fun(callback)) {
					//     callback(command, new_command_posation)
					// }

					// setTimeout(() => {
					axios
						.get('/command_var/get_all/' + new_command['command_id'])
						.then((res) => {
							if (res.data.status) {
								command.apis.variables = res.data.data || []
							}
							axios
								.get('/command_example/get/' + new_command['command_id'])
								.then((res) => {
									if (res.data.status == 1) {
										command.apis.example = {
											page: 1,
											pages_count: 1,
											data: {
												1: res.data.data.reduce((a, b) => {
													return a.concat({
														...b,
														mode: 'browse',
													})
												}, []),
											},
										}

										this.__set_paging(1, 1, (pagination_bar) => {
											command.apis.example.pagination = pagination_bar
										})
									}
									if (is_fun(callback)) {
										callback(command, new_command_posation)
									}
								})
								.catch((e) => {
									if (is_fun(callback)) {
										callback(command, new_command_posation, e)
									}
								})
						})
						.catch((e) => {
							if (is_fun(callback)) {
								callback(command, new_command_posation, e)
							}
						})
					// }, (new_command_posation + 1) * 2000)
				})
				.catch((e) => {
					if (is_fun(callback)) {
						callback(command, new_command_posation, e)
					}
				})
			// }, (new_command_posation + 1) * 100)
		},

		__build_command_secondary_row(command_response, command) {
			var secondary_row = ''
			command_response = command_response || {
				resp_type: 'error',
			}
			switch (command_response.resp_type) {
				case 'text':
					secondary_row = `<code class="highlighter-rouge c-dark">${command_response.resp_text}</code><br>`

					break
				case 'api':
					if ('text' == command_response.resp_api_resp_via || 'card' == command_response.resp_api_resp_via) {
						secondary_row = `<code class="highlighter-rouge c-dark">${
							command_response.resp_api_resp_struct.title_key
						}</code><br>`
					}
					break
				case 'sub':
					secondary_row = `<code class="highlighter-rouge c-dark">${command_response.resp_text}</code><br>`
					break
				case 'ds':
					var ds_vai = command_response.resp_dataset.resp.via
					if ('text' == ds_vai) {
						secondary_row = `<code class="highlighter-rouge c-dark">${
							command_response.resp_dataset.resp.title
						}</code><br>`
					} else if ('receipt' == ds_vai) {
						secondary_row = `<code class="highlighter-rouge c-dark">
                                    ${command_response.resp_dataset.resp.receipt.name}</code><br>`
					} else if ('card' == ds_vai) {
						secondary_row = `<code class="highlighter-rouge c-dark">${
							command_response.resp_dataset.resp.title
						}</code><br>`
					}
					if (command && command_response.resp_dataset.ds_id) {
						axios.get('/dataset/browse/' + command_response.resp_dataset.ds_id).then((res) => {
							if (res.data.status) {
								command.apis.dataset = res.data.data
							}
						})
					}
					break
				case 'data_source':
					break
				default:
					secondary_row = 'no response currently'
					break
			}
			return secondary_row
		},

		__set_paging(pages_count, active_page, callback) {
			active_page = parseInt(active_page)
			var pagination_bar = []
			for (var i = 0; i < parseInt(pages_count); i++) {
				var acti_ = false
				if (active_page === i + 1) {
					acti_ = true
				}
				pagination_bar.push({
					btn: (i + 1).toString(),
					activate: acti_,
				})
			}
			if (is_fun(callback)) {
				callback(pagination_bar)
			}
		},

		__save_examples(ex_obj, command_id, callback) {
			var exams = [],
				get_examples = (ex_arr) => {
					if (!ex_arr.length) {
						return []
					}
					var f = ex_arr.splice(0, 1)[0]
					return [].concat(
						f.mode == 'edit' || f.mode == 'add'
							? ((exam) => {

                                    var exam_obj = ex_obj['data'][exam['page']][exam['posation']]

									if (exam_obj) {
										exam['example_command_id'] = exam_obj['example_command_id'] = command_id
										exam_obj['mode'] = 'browse'
									}
									delete exam['variables']
                                    delete exam['page']
									return exam
							  })(f)
							: [],
						get_examples(ex_arr)
					)
				}
			for (var page in ex_obj.data) {
				exams = exams.concat(
					ex_obj.data[page].reduce((a, b) => {
						return a.concat({
							...b,
							page: page,
						})
					}, [])
				)
			}

            var examples = get_examples(exams.slice())

			axios
				.post(
					'/command_example/save_all/',
					{
						examples: examples,
					}
				)
				.then((res) => {
					// dump(res)
					if (is_fun(callback)) {
						callback()
					}
                })
                .catch(err => {
                    if (is_fun(callback)) {
						callback()
					}
                })
		},

		__update_autocomplete_structure() {
			this.autocomplete = Object.assign(this.autocomplete, clone(this.$store.state.autocomplete), {
				'@v': {
                    icon: 'fa-at',
					short_descroption: this.$t('variables'),
					list: [].concat(
						Object.values(this.$store.state.sender_info),
						(() => {
							var vars = []
							for (var i = 0; i < this.command.variables.length; ++i) {
								vars.push(this.command.variables[i].var_name)
							}
							return vars
						})()
					),
				},
			})
			// dump(this.command.variables)
        },

        imageUploaded(data) {

            const {file, response} = data;

            this.resp_static_cards_resp_struct.media_key = response.path;

            this.resp_static_cards_resp_struct
        }
	},
}
</script>
